import type { TypographyProps } from '@mui/material';
import { Tooltip, Typography } from '@mui/material';

const TruncateTextWithTooltip = ({
  children,
  charLimit = 20,
  ...props
}: TruncateTextWithTooltipProps & TypographyProps) => {
  const isTruncated = children?.length > charLimit;

  const truncatedText = isTruncated
    ? `${(children ?? '').slice(0, charLimit)}...`
    : children;

  return (
    <Tooltip title={children} disableHoverListener={!isTruncated}>
      <Typography {...props}>{truncatedText}</Typography>
    </Tooltip>
  );
};

export default TruncateTextWithTooltip;

type TruncateTextWithTooltipProps = {
  children: string;
  charLimit?: number;
};
